module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "personalIII"
    }
  }, [(_vm.personalIII.length === 0) ? [_c('underconstruction')] : [_c('vue-perfect-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexDisp),
      expression: "indexDisp"
    }],
    attrs: {
      "photos": _vm.personalIII,
      "togglePage": _vm.togglePage,
      "receivedDetail": _vm.receivedPersonalIIIDetail
    }
  }), _vm._v(" "), _c('vue-light-gallery', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailDisp),
      expression: "detailDisp"
    }],
    attrs: {
      "photos": _vm.personalIIIDetail,
      "togglePage": _vm.togglePage
    }
  })]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d4fee4f6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/personalIII/components/index.vue
// module id = 595
// module chunks = 2